var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-pagination',{staticStyle:{"margin-top":"1%","text-align":"right"},attrs:{"current":this.page,"page-size":this.size,"total":this.contentSize,"showSizeChanger":this.showSizeChanger,"pageSizeOptions":this.pageSizeOptions},on:{"change":_vm.change,"showSizeChange":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }